export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_52-4909b50767c08e3948693a353b8927c6.jpg";